import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-cream border-y border-silver-light" data-id="element-131" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-132" data-mp="223oejhmj3wdd">
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-paper border border-silver-light rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-133" data-mp="222n156i1ixsh">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gold" data-id="element-134" data-mp="1j52em62r0bb1" />
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-brand-soft text-brand-dark mb-8" data-id="element-135" data-mp="1ee3t8s2wkn0x">
            <ShieldCheck size={48} aria-hidden="true" data-id="element-136" data-mp="qn7vlebrmxlr" />
          </div>
          <h2 className="text-3xl md:text-4xl font-display font-extrabold mb-6 text-ink" data-id="element-137" data-mp="lpg0ycjqkxdv">
            Complete <span className="text-brand" data-id="element-138" data-mp="ozrmu7gdw7y8">7-Day Guarantee</span>
          </h2>
          <div className="space-y-6 text-lg text-graphite max-w-2xl mx-auto" data-id="element-139" data-mp="oxozxwaj2uxq">
            <p data-id="element-140" data-mp="twrxyws3c0w7">
              Open the complete teaching library. Explore all 5 bonuses. Use the material in your
              most challenging class this week.
            </p>
            <p className="font-medium text-ink" data-id="element-141" data-mp="12pmtgyrrai8s">
              If you find the material isn&apos;t clear, practical, or useful for your teaching
              needs, contact us within 7 days.
            </p>
            <p className="text-accent-dark font-bold text-xl" data-id="element-142" data-mp="b0a70hl2g510">
              We&apos;ll refund 100% of your payment. No questions. No forms. No hassle.
            </p>
            <p className="text-sm text-graphite-light mt-8" data-id="element-143" data-mp="k0ounnli5w7o">
              Because if the material doesn&apos;t deliver the value we promise, we don&apos;t want
              to keep your money.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}